export * from './directives';
export * from './services';
export { AgmCoreModule } from './core.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/HP Spectre/Desktop/Regineh Hotel/reginehUser/node_modules/@agm/core/index.js
// module id = ../../../../@agm/core/index.js
// module chunks = vendor